<template>
	<div class="wrapper">
		<side-bar>
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>របាយការណ៏</p>
			</sidebar-link>
			<sidebar-link to="/deposits">
				<md-icon>account_balance</md-icon>
				<p>ការដាក់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/withdraws">
				<md-icon>paid</md-icon>
				<p>ការដកប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/clients">
				<md-icon>diversity_3</md-icon>
				<p>អតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/reports">
				<md-icon>analytics</md-icon>
				<p>ទិន្នន័យស្ថិតិ</p>
			</sidebar-link>
			<sidebar-link to="/settings">
				<md-icon>settings</md-icon>
				<p>ការកំណត់</p>
			</sidebar-link>
			<sidebar-link to="/administrators">
				<md-icon>supervised_user_circle</md-icon>
				<p>ការកំណត់គណនី</p>
			</sidebar-link>
		</side-bar>


		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue